import { Plan } from "@/features/payments/models/plan";
import { Subscription } from "@/features/payments/models/subscription";
import { Link } from "react-router-dom";
import { ProfileManageMembershipRoute } from "../route";

function CurrentPlan({
	plan,
	subscription,
}: {
	plan?: Plan | null;
	subscription?: Subscription | null;
}) {
	return (
		<div className="flex flex-col gap-8">
			<div className="flex flex-row items-end justify-between">
				<p className="web-heading-h4">Current Plan</p>
				<Link
					className="web-button text-blue-700 md:hidden"
					to={ProfileManageMembershipRoute}
				>
					Upgrade Plan
				</Link>
			</div>

			<div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
				<div className="flex flex-row max-sm:w-full max-sm:justify-between md:flex-col md:gap-3">
					<p className="web-body-b1 text-gray-500">Name</p>
					<p className="web-body-b1-medium">{plan?.name || "N/A"}</p>
				</div>

				<div className="flex flex-row max-sm:w-full max-sm:justify-between md:flex-col md:gap-3">
					<p className="web-body-b1 text-gray-500">Price</p>
					<p className="web-body-b1-medium">
						{plan?.price ? "$" + plan.price : "N/A"}
					</p>
				</div>

				<div className="flex flex-row max-sm:w-full max-sm:justify-between md:flex-col md:gap-3">
					<p className="web-body-b1 text-gray-500">Join Date</p>
					<p className="web-body-b1-medium">
						{subscription?.startDate
							? new Date(subscription?.startDate).toLocaleDateString()
							: "N/A"}
					</p>
				</div>

				<Link
					className="web-button hidden text-blue-700 md:block"
					to={ProfileManageMembershipRoute}
				>
					Upgrade Plan
				</Link>
			</div>
		</div>
	);
}

export default CurrentPlan;
